import { Component, Inject, Input, OnChanges, SimpleChanges } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpParams } from "@angular/common/http";
import { AppComponent } from "../app/app.component";
import { fakeAsync } from "@angular/core/testing";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: "prequalification",
    template: require('./prequalification.component.html'),
    styles: [require('./prequalification.component.css')]
})
export class PrequalificationComponent implements OnChanges {

    report: CollisionReport;
    PictureCount: number = 0;
    progress: number = 0;
    message: string = "";

    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string, private translate: TranslateService,
        private router: Router) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }

        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
        this.getPhotosCount();
        document.body.scrollTop = 0;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
            }
        }
        else
            console.log("Undefined");
    }

    onBack(): void {
        this.BackAndPost("yourinfo");
    }

    private BackAndPost(page: string): void {
        this.report.CurrentPage = page;
        //this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }

    onSubmit(): void {
        if (this.report.EntityType != null && (this.report.EntityType == "PEDESTRIAN" || this.report.EntityType == "CYCLIST")) {
            if (!this.report.WereYouInjured) {
                this.ValidateAndPost("otherdriver");
            }
            else {
                this.ValidateAndPost("injury");
            }
        }
        else
            this.ValidateAndPost("statement");
    }

    onDidReportDirectlyChange(value: boolean): void {
        this.report.DidYouReportDirectly = value;
    }

    onWereYouInjuredChange(value: boolean): void {
        this.report.WereYouInjured = value;
    }

    onFailToRemainChange(value: boolean): void {
        this.report.FailToRemain = value;
    }

    onPoliceAttendedChange(value: boolean): void {
        this.report.PoliceAttended = value;
    }

    onApproachedChange(value: boolean): void {
        this.report.Approached = value;
    }

    private ValidateAndPost(page: string) {
        if (this.IsValid()) {
            //this.movefiles();
            this.report.IsPrequalificationPageValid = true;
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            this.router.navigate([page]);
        }
        else {
            alert("Please select all mandatory questions.");
        }
    }

    private IsValid(): boolean {
        if (
            this.report.WereYouInjured == null ||
            this.report.FailToRemain == null ||
            this.report.PoliceAttended == null
        ) {
            return false;
        }

        return true;
    }

    upload(files: any) {
        console.log("Uploading");
        var url = this.baseUrl + "api/Upload/UploadFile";
        if (files.length === 0)
            return;

        //for (var x in files) {

        //    var filesize: number = Number.parseFloat(((files[x].size / 1024) / 1024).toFixed(4)); // MB

        //    if (files[x].name != "item" && typeof files[x].name != "undefined" && filesize <= 4) {
        //        return;
        //    }
        //}

        var id = this.report.CollisionReportId.toString();

        let params = new HttpParams();

        const formData = new FormData();

        for (let file of files) {
            var ext = file.name.split('.').pop().toLowerCase(); // Check image file extension

            if (ext == 'jpg' || ext == 'jpeg' || ext == 'png') {
                formData.append(file.name, file);
            }
            else {
                //let msg = this.translate.get('Prequalification.InvalidFileFormat');
                let msg = 'Photo not uploaded. (Supported formats: jpg, jpeg): ';
                alert(msg + file.name);
            }
        }

        const uploadReq = new HttpRequest('POST', url, formData, {
            reportProgress: true,
            params: params
        });

        this.http.request(uploadReq).subscribe(event => {

            if (event.type === HttpEventType.UploadProgress) {
                if (event.total == 0 || event.total == undefined) {
                    event.total = 1
                    this.progress = Math.round(100 * event.loaded / event.total);
                }
            }
            else
                if (event.type === HttpEventType.Response)
                    if (event.body == null || event.body == undefined) {
                        this.message = "No message";
                    }
                    else {
                        this.message = event.body.toString();
                    }

            this.getPhotosCount();
        });
    }

    movefiles() {
        var id = this.appcomponent.getReport().CollisionReportId;
        var url = this.baseUrl + "api/Upload/" + "MoveFolder/" + id;
        var data;

        this.http
            .get(url)
            .subscribe(res => {
                data = res.toString()
                if (data != null) {
                }
                else {
                }
                
            }, error => console.log(error));
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }

    getPhotosCount(): void {
        var url = this.baseUrl + "api/Upload/getphotoscount";
        this.http
            .get(url)
            .toPromise().then(result => {
                console.log(result);
                var v = result as number;
                this.PictureCount = v;
            });
    }
}